<template>
  <b-card title="Görüşme Konuları">
    <b-row v-show="subjects.chart.series.length > 0">
      <b-col>
        <apex-donut-chart
          :categories-data="subjects.chart.categories"
          :series-data="subjects.chart.series"
        />
      </b-col>
      <b-col class="d-flex align-items-center">
        <b-list-group class="w-100">
          <b-list-group-item
            v-for="item in subjects.data"
            :key="item.id"
          >
            <div class="d-flex justify-content-between">
              <div class="font-weight-bold text-primary">
                {{ item.title }}
              </div>
              <div class="font-weight-bold">
                {{ item.count }} Adet
              </div>
            </div>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
    <empty-alert v-if="subjects.chart.series.length === 0" />
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import ApexDonutChart from '@/views/Admin/Reports/charts/ApexDonutChart.vue'
import EmptyAlert from '@/views/Admin/Reports/common/EmptyAlert.vue'

export default {
  name: 'Subjects',
  components: {
    BCard,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,
    ApexDonutChart,
    EmptyAlert,
  },
  computed: {
    subjects() {
      return this.$store.getters['interviewReports/subjects']
    },
  },
}
</script>
